import { useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { accountServices } from "../../../../APIServices/PasswordManagement/accountServices";

const CreateNewAccount = ({ auth, Show, Hide, Title, isDark, getAccountList, setUpdator }) => {
  const [accountName, setAccountName] = useState("");
  const [description, setDescription] = useState("");
  const [loader, setLoader] = useState(false);

  const addNewAccount = async () => {
    let userData = {}
    setLoader(true)
    userData.name = accountName
    userData.description = description
    let data = await accountServices.addNewAccount(auth, userData)
    if (data?.statusCode === 200) {
      setAccountName("")
      setDescription("")
      getAccountList()
      setUpdator(`accountList_${Math.floor(10000 + Math.random() * 90000)}`);
      Hide()
    }
    setLoader(false)
  }

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className={`${isDark ? "bg-dark" : "bg-light" } p-3 border-bottom`}>
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Account Name{" "}
            <abbr className="text-danger" title="Require">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            type="text"
            value={accountName}
            onChange={(e) => setAccountName(e.target.value)}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Account Name"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Description (optional)
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="What should this account use for?"
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className={`${isDark ? "bg-dark" : "bg-light" } p-2 border-top text-end`}>
        <Button
          variant="outline-primary"
          disabled={!accountName || loader}
          onClick={addNewAccount}
          style={{ fontSize: 13 }}
          className="rounded-1 py-1 px-3"
          title={Title}
        >
          {Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default CreateNewAccount;
